// The organisation the person works in (GIOTHUB-186): a person may belong
// to several; the choice is remembered per browser and sent with every API
// call as X-Builder-Org. Without one the server uses the first enabled
// organisation.
const KEY = "gtb.org";

export function activeOrg(): string {
  try {
    return localStorage.getItem(KEY) || "";
  } catch {
    return "";
  }
}

export function setActiveOrg(id: string) {
  try {
    if (id) localStorage.setItem(KEY, id);
    else localStorage.removeItem(KEY);
  } catch {
    /* not remembered */
  }
}
